import { EventEmitter, Injectable } from '@angular/core';
import { EditableBlockInterface } from '../editable-block-interface';

@Injectable({providedIn: 'root'})
export class EditorService {
    public blockClicked = new EventEmitter<any>();
    private previousSelectedComponent: EditableBlockInterface | null = null;

    public blockClickedEvent(item: any, component: EditableBlockInterface, event: MouseEvent) {
        event.stopPropagation();

        if (this.previousSelectedComponent) {
            this.previousSelectedComponent.toggleSelected(false);
        }

        component.toggleSelected(true);

        this.previousSelectedComponent = component;
        this.blockClicked.emit([item, component, event]);
    }
}
